import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web and AsyncStorage for react-native
import { setupListeners } from '@reduxjs/toolkit/dist/query'

import { approvalStatusApi } from "./api/approvalStatusApi";
import { businessApi } from "./api/businessApi";
import { buttonApi } from "./api/buttonApi";
import { itemCodeApi } from "./api/itemCodeApi";
import { logInformationApi } from "./api/logInformationApi";
import { menuApi } from "./api/menuApi";
import { requestApi } from "./api/requestApi";
import { bidsApi } from "./api/bidsApi";
import { statusApi } from "./api/statusApi";
import { userApi } from "./api/userApi";
import { authReducer } from "./slice/authSlice";
import { mainToCardReducer } from "./slice/mainToCardSlice";
import { tokenSlice } from "./slice/tokenSlice";
import { dataGridReducer } from "./slice/dataGridSlice";
import { vendorApi } from "./api/vendorApi";
import { groupApi } from "./api/groupApi";
import { buttonReducer } from "./slice/buttonSlice";
import { buyerApi } from "./api/buyerApi";
import { analysisCodeApi } from "./api/analysisCodeApi";
import { dialogReducer } from "./slice/dialogSlice";
import { tabIndexReducer } from "./slice/tabIndexSlice";
import { approvalApi } from "./api/approvalApi";
import { analysisDimensionApi } from "./api/analysisDimensionApi";
import { analysisStructureApi } from "./api/analysisStructureApi";
import { attachmentApi } from "./api/attachmentApi";
import { evaluationFormApi } from "./api/evaluationFormApi";
import { persistDataReducer } from "./slice/persistSlice";
import { supplierEvaluationApi } from "./api/supplierEvaluationApi";
import { otherReducer } from "./slice/otherSlice";
import { rfqDataReducer } from "./slice/rfqSlice";
import { bidsDataReducer } from "./slice/bidsSlice";
import { orderApi } from "./api/orderApi";
import { bidComparsionSliceDataReducer } from "./slice/bidComparsionChart";
import { uploadApi } from "./api/uploadApi";
import { paymentApi } from "./api/paymentApi";
import { paymentDataReducer } from "./slice/paymentSlice";
import { invoiceDataReducer } from "./slice/invoiceSlice";
import { reportApi } from "./api/reportApi";

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['auth', 'userSlice', 'alert', 'request', 'number', 'user', 'menu', tokenSlice.reducerPath, 'counter', 'otherSlice'],
    whitelist: ['dataGridSlice', 'persistSlice', 'tabIndexSlice']
};

const persistedReducer = persistReducer(persistConfig, combineReducers({
    user: userApi.reducer,
    menu: menuApi.reducer,
    button: buttonApi.reducer,
    business: businessApi.reducer,
    itemCode: itemCodeApi.reducer,
    requestApi: requestApi.reducer,
    bidsApi: bidsApi.reducer,
    paymentApi: paymentApi.reducer,
    status: statusApi.reducer,
    report: reportApi.reducer,
    approvalStatus: approvalStatusApi.reducer,
    logInformation: logInformationApi.reducer,
    vendor: vendorApi.reducer,
    group: groupApi.reducer,
    buyer: buyerApi.reducer,
    analysis: analysisCodeApi.reducer,
    approval: approvalApi.reducer,
    evaluationForm: evaluationFormApi.reducer,
    attachment: attachmentApi.reducer,
    analysisCode: analysisCodeApi.reducer,
    analysisDimension: analysisDimensionApi.reducer,
    analysisStructure: analysisStructureApi.reducer,
    supplierEvaluation: supplierEvaluationApi.reducer,
    uploadApi: uploadApi.reducer,
    order: orderApi.reducer,
    auth: authReducer,
    mainToCard: mainToCardReducer,
    tabIndexSlice: tabIndexReducer,
    buttonSlice: buttonReducer,
    otherSlice: otherReducer,
    dataGridSlice: dataGridReducer,
    dialogSlice: dialogReducer,
    [tokenSlice.reducerPath]: tokenSlice.reducer,
    persistSlice: persistDataReducer,
    rfqSlice: rfqDataReducer,
    invoiceSlice: invoiceDataReducer,
    bidsSlice: bidsDataReducer,
    paymentSlice: paymentDataReducer,
    bidComparsionSlice: bidComparsionSliceDataReducer,
}));

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            serializableCheck: false,
        })
            .concat(userApi.middleware)
            .concat(menuApi.middleware)
            .concat(buttonApi.middleware)
            .concat(businessApi.middleware)
            .concat(itemCodeApi.middleware)
            .concat(requestApi.middleware)
            .concat(bidsApi.middleware)
            .concat(statusApi.middleware)
            .concat(reportApi.middleware)
            .concat(vendorApi.middleware)
            .concat(approvalStatusApi.middleware)
            .concat(logInformationApi.middleware)
            .concat(groupApi.middleware)
            .concat(buyerApi.middleware)
            .concat(analysisCodeApi.middleware)
            .concat(approvalApi.middleware)
            .concat(evaluationFormApi.middleware)
            .concat(analysisDimensionApi.middleware)
            .concat(analysisStructureApi.middleware)
            .concat(attachmentApi.middleware)
            .concat(supplierEvaluationApi.middleware)
            .concat(orderApi.middleware)
            .concat(tokenSlice.middleware)
            .concat(uploadApi.middleware)
            .concat(paymentApi.middleware)

    },
    devTools: true
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);